export default "__VITE_ASSET__CESo5_HE__"